import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { GeometryType } from "@nova/constants"
import { DeckGLGeometry } from "plugins/shared/layers/types"
import { OrthoMask } from "@nova/protobuf"

export const UNSAVED_ORTHO_MASK_ID = "MOCKED_NEW_ORTHO_MASK_ID"

export type OrthoMaskDrawingType = "edit" | "polygon" | "rectangle"

type OrthoMaskState = {
    editingFlightId: string | null
    editingMaskId: string | null
    unsavedMask: DeckGLGeometry | undefined
    drawingType: OrthoMaskDrawingType
    resetKey: number
}

const initialState: OrthoMaskState = {
    editingFlightId: null,
    editingMaskId: null,
    unsavedMask: undefined,
    drawingType: "polygon",
    resetKey: 0,
}

const { reducer: orthoMaskReducer, actions } = createSlice({
    name: "ortho-mask",
    initialState,
    reducers: {
        startMaskDrawing: (
            state,
            action: { payload: { flightId: string; existingMask?: OrthoMask } }
        ) => {
            const { flightId, existingMask } = action.payload
            state.editingFlightId = flightId
            state.editingMaskId = existingMask?.id ?? null
            state.unsavedMask = {
                geometryType: existingMask ? GeometryType.Polygon : GeometryType.Line,
                coordinates: existingMask?.polygon?.coordinates ?? [],
                id: existingMask?.id ?? UNSAVED_ORTHO_MASK_ID,
                idx: 0,
            }
            state.drawingType = existingMask ? "edit" : "polygon"
        },
        cancelMaskDrawing: (state) => {
            state.editingFlightId = null
            state.editingMaskId = null
            state.unsavedMask = undefined
        },
        setDrawingType: (state, action: { payload: OrthoMaskDrawingType }) => {
            state.drawingType = action.payload
        },
        bumpResetKey: (state) => {
            state.resetKey += 1
        },
    },
})

export const { startMaskDrawing, cancelMaskDrawing, setDrawingType, bumpResetKey } = actions

export const OrthoMaskReducer = orthoMaskReducer
export const reducer = { "ortho-mask": OrthoMaskReducer }

export const selectOrthoMaskEditingFlightId = (state: RootState) =>
    state["ortho-mask"].editingFlightId
export const selectOrthoMaskEditingMaskId = (state: RootState) => state["ortho-mask"].editingMaskId
export const selectOrthoUnsavedMask = (state: RootState) => state["ortho-mask"].unsavedMask
export const selectIsDrawingOrthoMask = (state: RootState) =>
    state["ortho-mask"].editingFlightId !== null
export const selectOrthoMaskDrawingType = (state: RootState) => state["ortho-mask"].drawingType
export const selectOrthoMaskResetKey = (state: RootState) => state["ortho-mask"].resetKey
